"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Accordion = require("b2b-components/theme/components/Accordion");
var _device = require("b2b-components/utils/device");
var _classnames = _interopRequireDefault(require("classnames"));
var _TabHeader = require("./TabHeader");
var _Tabs = require("./Tabs.types");
require("./Tabs.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Tabs = _ref => {
  let {
    children,
    tabId,
    selectedTabIdx,
    deviceType,
    displayType = _Tabs.TABS_DISPLAY_TYPE.horizontal,
    triggerType,
    className,
    tabContentClassName
  } = _ref;
  const componentClassNames = displayType === _Tabs.TABS_DISPLAY_TYPE.horizontal ? {
    container: 'cds-TabsContainer--Horizontal',
    tabs: 'cds-Tabs--Horizontal',
    content: 'cds-TabContent--Horizontal'
  } : {
    container: 'cds-TabsContainer--Vertical',
    tabs: 'cds-Tabs--Vertical',
    content: 'cds-TabContent--Vertical'
  };
  const [activeTab, setActiveTab] = (0, _react.useState)(selectedTabIdx || 0);
  if ((0, _device.isMobile)(deviceType)) {
    return /*#__PURE__*/_react.default.createElement(_Accordion.Accordion, {
      defaultOpenIndexArray: [0],
      sectionClassName: "cds-TabHeader--Mobile",
      sectionTitleClassName: "cds-TabHeaderTitle--mobile",
      className: className
    }, children.map((tab, idx) => /*#__PURE__*/_react.default.createElement(_Accordion.Section, {
      key: idx,
      sectionId: tabId,
      title: tab.props.title,
      titleSize: _Accordion.TITLE_SIZE.large
    }, tab)));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(componentClassNames.container, className)
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _classnames.default)('cds-Tabs', componentClassNames.tabs)
  }, children.map((tab, idx) => {
    const {
      title: tabTitle,
      triggerType: tabTriggerType,
      className,
      dataAttributes
    } = tab.props;
    return /*#__PURE__*/_react.default.createElement(_TabHeader.TabHeader, {
      dataAttributes: dataAttributes,
      key: idx,
      title: tabTitle,
      isActive: idx === activeTab,
      onTrigger: () => setActiveTab(idx),
      triggerType: tabTriggerType || triggerType,
      className: className
    });
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('cds-TabContent', componentClassNames.content)
  }, children.filter((tab, idx) => idx === activeTab).map((tab, idx) => /*#__PURE__*/_react.default.createElement("div", {
    key: idx,
    className: tabContentClassName
  }, tab))));
};
exports.Tabs = Tabs;
//# sourceMappingURL=Tabs.js.map